// Return a base URL for accessing the server endpoints
export const renderServerBase = () => {
	// Get the hostname of the current request
	const currentHost = window.location.hostname

	// Production domains
	const domains = ["trackside-hospitality.visacashapprb.com", "www.trackside-hospitality.visacashapprb.com", "trackside-hospitality-prod-0c7cb6c31a9c.herokuapp.com"]

	// Check the environment we're currently running in
	if (domains.includes(currentHost)) {
		// Production host
		return "https://trackside-hospitality.visacashapprb.com/api"
	} else if (currentHost === "localhost" || currentHost === "") {
		// localhost server use port 8080,
		return "http://localhost:8080/api"
		// Local host server - use the staging host
		// return "https://trackside-hospitality-stage.visacashapprb.com/api"
		// return "https://trackside-hospitality.visacashapprb.com/api"
	} else {
		// Anything else, process on the staging host
		// TODO: swap once custom domains are setup
		// return "https://trackside-hospitality-stage.visacashapprb.com/api"
		return "https://trackside-hospitality.visacashapprb.com/api"
	}
}
